import { ChevronDown, ChevronRight } from 'lucide-react'
import { useState } from 'react'

interface CollapsiblePromptProps {
  text: string
  className?: string
  maxWords?: number
}

export const CollapsiblePrompt = ({
  text,
  className = 'text-xs-400 text-secondary',
  maxWords = 30,
}: CollapsiblePromptProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const words = text.split(' ')
  const shouldCollapse = words.length > maxWords
  const truncatedText = shouldCollapse ? `${words.slice(0, maxWords).join(' ')}...` : text

  if (!shouldCollapse) {
    return <div className={`${className} min-w-0 break-words [overflow-wrap:anywhere]`}>{text}</div>
  }

  return (
    <div className={className}>
      <div className="flex items-start gap-1">
        <button
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex shrink-0 items-center gap-1 rounded text-secondary hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-colors"
          aria-expanded={isExpanded}
          aria-label={isExpanded ? 'Collapse prompt' : 'Expand prompt'}
          data-testid="button-toggle-prompt"
        >
          {isExpanded ? (
            <ChevronDown size={14} className="shrink-0 mt-0.5" />
          ) : (
            <ChevronRight size={14} className="shrink-0 mt-0.5" />
          )}
        </button>
        <div className="flex-1 min-w-0 break-words [overflow-wrap:anywhere]">
          {isExpanded ? text : truncatedText}
        </div>
      </div>
    </div>
  )
}
